export default "__VITE_ASSET__DVZCmbyF__"